import { Card, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { Placeholder, PlaceholderMedia, Shine } from 'rn-placeholder';

export const ProductListPlaceHolder = () => {
  return (
    <>
      <YStack backgroundColor={'$discoverPlaceHolderBg'} paddingTop={40}>
        <Card
          shadowColor={'$discoverPlaceHolderBg'}
          shadowRadius={5}
          elevation={5}
          marginHorizontal={5}
          shadowOpacity={0.2}
          marginVertical={10}
          backgroundColor="$background"
        >
          <XStack flexDirection="row" display="flex" marginBottom={5} marginRight={5}>
            <YStack height={200} width={320} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 320, height: 200, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
            <YStack height={200} width={320} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 320, height: 200, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
          </XStack>

          {/* // Loader for Video Small Cards */}

          <XStack
            flexDirection="row"
            display="flex"
            marginBottom={5}
            marginTop={10}
            marginRight={5}
          >
            <YStack height={150} width={230} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 230, height: 150, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
            <YStack height={150} width={230} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 230, height: 150, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
          </XStack>

          {/* // Loader for Video Playlist Cards */}

          <XStack flexDirection="row" display="flex" marginBottom={5} marginRight={5}>
            <YStack height={170} width={140} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 140, height: 170, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
            <YStack height={170} width={140} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 140, height: 170, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
            <YStack height={170} width={140} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 140, height: 170, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
          </XStack>

          {/* // Loader for Video Small Cards */}

          <XStack
            flexDirection="row"
            display="flex"
            marginBottom={5}
            marginTop={10}
            marginRight={5}
          >
            <YStack height={150} width={230} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 230, height: 150, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
            <YStack height={150} width={230} marginBottom={15} margin={3} borderRadius={10}>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 230, height: 150, borderRadius: 10 }]} />
              </Placeholder>
            </YStack>
          </XStack>
        </Card>
      </YStack>
    </>
  );
};
